module.exports = __webpack_public_path__ + "static/media/construction.6804bf10.svg";